import React, { Component } from 'react';
import axios from 'axios';

import { Row, Col, Button } from 'react-bootstrap';

import SignatureField from './SignatureField';

require(`../assets/${process.env.PAGE}/css/components/signature-form.css`);

class SignatureForm extends Component {
    constructor(props){
        super(props);

        this.state = {
            signed: false,
            loading: false,
        }

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const { onChange } = this.props;
        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };

        axios.get(`${ROOT_URL}/leads/signature`, config)
        .then((response)=> {
            this.setState({
                signed: response.data.signed,
                loading: false,
            });
            onChange(response.data.signed);
        });

    }

    handleSubmit(signature){
        const { onChange } = this.props;
        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };

        this.setState({ loading: true });

        const formData = new FormData();
        formData.append('file', signature.blobFile);
        formData.append('md5', signature.md5Sum);

        axios.post(`${ROOT_URL}/leads/signature`, formData, config)
        .then((response)=> {
            this.setState({
                loading: false ,
                signed: true,
            });
            onChange(true);
        });
    }

    render() {
        const { disabled } = this.props;
        const { loading, signed } = this.state;

        let button = (
            <SignatureField
                onChange={this.handleSubmit}
                className={'signature-button'}
                headerTitle="Al firmar lo estoy haciendo por todos los documentos mostrados en la pantalla anterior"
                disabled={disabled}
            />
        );

        if (loading || signed) {
            button = (
                <Button
                    className={"btn btn-warning btn-sm pd-simple-button signature-button" + (signed ? ' pd-button-accepted-contract ' : '')}
                    disabled={true}
                >
                    { loading ? 'Verificando firma' : 'Firmado'}
                </Button>
            );
        }

        return (
            <Row className="terms_row">
                <Col className="terms_col terms_checkbox text-center" xs={12} md={12} lg={12}>
                    {button}
                </Col>
            </Row>
        );
    }
}

export default SignatureForm;


/** WEBPACK FOOTER **
 ** ./src/components/SignatureForm.js
 **/